import { connect } from 'react-redux';
import RatingSuccessPage from './RatingSuccessPage';

export default connect()(RatingSuccessPage);
